// General Styles

const img = {
    maxWidth: '100%',
    height: 'auto'
}

const paper = theme => ({
    padding: theme.spacing(3),
})

const divider = theme => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
})

const adminPageTitle = {
    fontSize: '1.8rem',
    fontWeight: '400'
}

export {
    img,
    paper,
    divider,
    adminPageTitle
}
